export default "__VITE_ASSET__BXI62ref__"